import BaseModel from '../../base';
import EventAttribute from '../../event-attribute';

export default class AttributeAutocomplete extends BaseModel {
  constructor(item = {}, url = '') {
    super(item, url);

    this.owner_id = item.owner_id;
    this.attribute_id = item.attribute_id;
    this.value = item.value;

    this.created_at = item.created_at;
    this.updated_at = item.updated_at;

    // expand
    this.attribute = item.attribute ? new EventAttribute(item.attribute) : undefined;
  }

  get title() {
    return this.attribute?.title || '';
  }
}
